import { isFunction, isEmpty } from 'lodash';
import { Core } from '../core/core';
import { dispatch } from '../store/dispatch';

/**
 * Transfer state from cache to memory based on a path
 *
 * @export
 * @param {string} [path]
 * @returns
 */
export async function feedState(key?: string) {
    const hasStorage = isFunction(Core.storage.forEach);

    if (hasStorage) {
        if (key) {
            const cache = await Core.storage.get(key);
            if (!isEmpty(cache)) {
                dispatch({
                    type: 'MEMO_UPDATE',
                    key: key,
                    value: cache,
                });
            }
        } else {
            Core.storage.forEach((value, k, index) => {
                dispatch({
                    type: 'MEMO_UPDATE',
                    key: k,
                    value: value,
                });
            });
        }
    } else {
        throw new Error(`Can't locate storage instance`);
    }
}
